import getIFrameElementById from '../../getIFrameElementById';
import {
  ZendeskCustomStyleSheet,
  ZendeskDepartments,
  ZendeskStatus,
  ZendeskWidgetModules
} from '../../../types/zendesk.d';
import { zendeskWidgetConfig } from './zendeskWidgetConfig';

const addZendeskCustomStyleSheetsToWidgetModule = (
  sheets: ZendeskCustomStyleSheet[],
  module: ZendeskWidgetModules
): void => {
  if (sheets != null && sheets.length && module != null) {
    const iframe = getIFrameElementById(module);

    if (iframe != null && iframe.contentWindow != null) {
      const customLauncherStyleSheets = iframe.contentDocument?.querySelectorAll(
        `head > link#custom-launcher-css, head > link#custom-widget-css`
      );

      sheets.forEach(sheet => {
        if (sheet != null) {
          const link = document.createElement('link');
          link.href = sheet.path;
          link.id = sheet.id;
          link.rel = 'stylesheet';
          link.type = 'text/css';

          iframe.contentWindow?.document.head.append(link);
        }
      });

      if (customLauncherStyleSheets != null && customLauncherStyleSheets.length) {
        customLauncherStyleSheets.forEach(sheet => sheet.remove());
      }
    }
  }
};

const getPathOfLauncherCustomStyleSheet = (
  status: ZendeskStatus,
  department: ZendeskDepartments
): ZendeskCustomStyleSheet | null => {
  if (status === ZendeskStatus.Offline) {
    return zendeskWidgetConfig.styles.launcher.types.support;
  }

  if (status === ZendeskStatus.Online) {
    if (department === ZendeskDepartments.CustomerCare) {
      return zendeskWidgetConfig.styles.launcher.types.customerCare;
    }

    if (department === ZendeskDepartments.PrivateClientAdvisors) {
      return zendeskWidgetConfig.styles.launcher.types.PCA;
    }
  }

  return null;
};

export const rescaleZendeskLauncher = (): void => {
  const iframe: HTMLIFrameElement | null = getIFrameElementById(ZendeskWidgetModules.Launcher);

  if (iframe != null) {
    iframe.style.height = zendeskWidgetConfig.styles.launcher.height;
  }
};

export const styleZendeskLauncher = (
  status: ZendeskStatus,
  department: ZendeskDepartments
): void => {
  const customStyleSheetPath = getPathOfLauncherCustomStyleSheet(status, department);

  if (customStyleSheetPath !== null) {
    addZendeskCustomStyleSheetsToWidgetModule(
      [zendeskWidgetConfig.styles.widget, customStyleSheetPath],
      ZendeskWidgetModules.Launcher
    );

    rescaleZendeskLauncher();
  }
};

/** launcher styles */

export const styleZendeskLauncherForOfflineSupport = (): void => {
  styleZendeskLauncher(ZendeskStatus.Offline, ZendeskDepartments.CustomerCare);
};

export const styleZendeskLauncherForOnlineStylingSupport = (): void => {
  styleZendeskLauncher(ZendeskStatus.Online, ZendeskDepartments.PrivateClientAdvisors);
};

export const styleZendeskLauncherForOnlineSupport = (): void => {
  styleZendeskLauncher(ZendeskStatus.Online, ZendeskDepartments.CustomerCare);
};

/** widget body styles */

export const styleZendeskWidget = (): void => {
  addZendeskCustomStyleSheetsToWidgetModule(
    [zendeskWidgetConfig.styles.widget],
    ZendeskWidgetModules.Widget
  );
};
